import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export const ScrollProgress = () => {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-amber-500 origin-left z-50" style={{
      scaleX
    }} data-id="element-1425" />
      {isVisible && <motion.button className="fixed bottom-6 right-6 w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center z-40 shadow-lg" onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} data-id="element-1426">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1427">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" data-id="element-1428" />
          </svg>
        </motion.button>}
    </>;
};